import { useContext, useEffect, useLayoutEffect, useState } from 'react'

import usePreviousProps from '../../hooks/previous_props_hook'
import {
  WIDGET_LAYOUT,
  collectionScrollBox,
  iframeElements, embeddedContainer,
} from '../../pages/live_chat/constants'
import { WidgetContext } from '../../pages/live_chat/widget_page_router'
import { PREVIEWING_STATE_CHANGE_EVENT } from './welcome_video'

export const useCarouselPreviewManager = () => {
  const [intersectingStates, setIntersectingStates] = useState(
    Array(iframeElements.length),
  )
  const {
    widgetLayout,
    positionInCollection,
    prevCarouselScrollLeft,
    isCollectionIntersecting,
  } = useContext(WidgetContext)
  const prevWidgetLayout = usePreviousProps(widgetLayout)
  const prevPositionInCollection = usePreviousProps(positionInCollection)

  // when the position in the carousel changes, start previewing the first visible widget
  useEffect(() => {
    for (let i = 0; i < intersectingStates.length; i++) {
      if (intersectingStates[i] === 1) {
        iframeElements.forEach((iframe) => {
          iframe.contentWindow.dispatchEvent(
            new CustomEvent(PREVIEWING_STATE_CHANGE_EVENT, {
              detail: iframe === iframeElements[i],
            }),
          )
        })
        return
      }
    }
    iframeElements.forEach((iframe) => {
      iframe.contentWindow.dispatchEvent(
        new CustomEvent(PREVIEWING_STATE_CHANGE_EVENT, {
          detail: false,
        }),
      )
    })
  }, [intersectingStates])

  // used to determine which widgets are visible in the carousel
  useEffect(() => {
    if (
      type !== 'carousel' ||
      widgetLayout !== WIDGET_LAYOUT.EMBEDDED ||
      !isCollectionIntersecting
    ) {
      setIntersectingStates(Array(iframeElements.length))
      return
    }
    const onIntersectionChange = (entries: IntersectionObserverEntry[]) => {
      setIntersectingStates((prevState) => {
        const newState = [...prevState]
        entries.forEach((entry) => {
          const index = iframeElements.indexOf(entry.target)
          newState[index] = entry.intersectionRatio
        })
        return newState
      })
    }
    const io = new IntersectionObserver(onIntersectionChange, {
      root: embeddedContainer,
      threshold: [0, 0.0001, 1],
    })
    iframeElements.forEach((iframe) => {
      io.observe(iframe)
    })

    return () => {
      io.disconnect()
    }
  }, [widgetLayout, isCollectionIntersecting])

  // restore scroll position in the carousel after leaving fullscreen
  useLayoutEffect(() => {
    if (
      prevWidgetLayout === WIDGET_LAYOUT.FULLSCREEN &&
      widgetLayout !== WIDGET_LAYOUT.FULLSCREEN &&
      prevPositionInCollection === 0
    ) {
      setTimeout(() => {
        collectionScrollBox.scrollLeft = prevCarouselScrollLeft.current
      }, 1)
    }
  }, [
    positionInCollection,
    prevCarouselScrollLeft,
    prevPositionInCollection,
    prevWidgetLayout,
    widgetLayout,
  ])
}

// eslint-disable-next-line
// @ts-ignore
const { type } = window.speakeasySettings
